import { ISpotBase } from '../../models/spots';
import {
  IUserCategoryBase,
  IUserCategoryHikcentralOrganizationBase,
} from '../../models/userCategories';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IDetailedUserCategory extends IUserCategoryBase {
  hikcentralOrganization: IUserCategoryHikcentralOrganizationBase;
}

export interface IDetailedVenture extends IVentureBase {
  spots: ISpotBase[];
  userCategories: IDetailedUserCategory[];
}

export const showVenturesService = async (
  ventureId: string,
): Promise<IDetailedVenture> => {
  const { data } = await jhsfBookingsApi.get<IDetailedVenture>(
    `/ventures/${ventureId}`,
  );

  return data;
};
